// import React, { useEffect, useState } from "react";
// import styled from "styled-components";
// import { Link } from "react-router-dom";
// import { FaSearch } from "react-icons/fa";

// import categoryData from "../../DataJS/categories.js";
// import productsArray from "../../DataJS/Products.js";

// const Product = () => {
//   const [products, setProducts] = useState([]);
//   const [categories, setCategories] = useState([]);

//   const [selectedCategory, setSelectedCategory] = useState("All");

//   useEffect(() => {
//     setProducts(productsArray);
//     setCategories(categoryData);
//   }, []);

//   // Filter Products
//   const filteredProducts =
//     selectedCategory === "All"
//       ? products
//       : products.filter((product) => {
//           const category = categories.find(
//             (item) => item.id === product.categoryId,
//           );
//           return category?.category === selectedCategory;
//         });

//   return (
//     <Wrapper>
//       <section
//         className="rs-breadcrumb-area rs-breadcrumb-one p-relative"
//         style={{
//           paddingTop: "45px",
//           paddingBottom: "45px",
//         }}
//       >
//         <div
//           className="rs-breadcrumb-bg"
//           style={{
//             backgroundImage: "url(/assets/images/bg/breadcrumb-bg-01.png)",
//           }}
//         ></div>
//         <div className="container">
//           <div className="row">
//             <div className="col-xxl-6 col-xl-8 col-lg-8">
//               <div className="rs-breadcrumb-content-wrapper">
//                 <div className="rs-breadcrumb-title-wrapper">
//                   <h1 className="rs-breadcrumb-title fs-1">Products</h1>
//                 </div>
//                 <div className="rs-breadcrumb-menu">
//                   <nav>
//                     <ul>
//                       <li>
//                         <span>
//                           <Link to="/">Home</Link>
//                         </span>
//                       </li>
//                       <li>
//                         <span>Products</span>
//                       </li>
//                     </ul>
//                   </nav>
//                 </div>
//               </div>
//             </div>
//           </div>
//         </div>
//       </section>

//       <section className="rs-shop-area section-space">
//         <div className="container">
//           <div className="row g-5">
//             <div className="col-xxl-8 col-xl-8 col-lg-8">
//               <div className="rs-shop-meta-wrapper">
//                 <div className="rs-product-item-count">
//                   <span> Showing 1–9 of 12 results</span>
//                 </div>
//                 <div className="rs-shop-filter-wrapper">
//                   <div className="rs-shorting-select">
//                     <select name="subject">
//                       <option>Default Shorting</option>
//                       <option value="one">Sort by popularity</option>
//                       <option value="two">Sort by average rating</option>
//                       <option value="three">Sort by latest</option>
//                       <option value="four">Sort by price: low to high</option>
//                       <option value="five">Sort by price: high to low</option>
//                     </select>
//                   </div>
//                 </div>
//               </div>
//             </div>
//           </div>

//           <div className="row g-5">
//             <div className="col-xxl-8 col-xl-8 col-lg-8">
//               <div className="row g-5">
//                 {/* {products.map((product) => { */}
//                 {filteredProducts.length > 0 ? (
//                   filteredProducts.map((product) => {
//                     return (
//                       <div
//                         key={product.id}
//                         className="col-xl-4 col-lg-6 col-md-6 col-sm-6"
//                       >
//                         {/* <div className="rs-product-item">
//                           <div
//                             className="rs-product-thumb"
//                             style={{ border: "1px solid #eeeeee" }}
//                           >
//                             <Link
//                               to={`/products/product-details/${product.id}`}
//                             >
//                               <img
//                                 src={product.image}
//                                 alt="imagee"
//                                 style={{ width: "300px", height: "300px" }}
//                               />
//                             </Link>
//                             {product.sale && (
//                               <div className="rs-product-badge">
//                                 <span className="rs-circle-badge">Sale!</span>
//                               </div>
//                             )}
//                             <div className="rs-product-btn">
//                             <Link
//                               className="rs-btn"
//                               to={`/products/product-details/${product.id}`}
//                             >
//                               Add To Cart
//                             </Link>
//                           </div>
//                           </div>
//                           <div className="rs-product-content">
//                             <h6 className="rs-product-title">
//                               <Link
//                                 to={`/products/product-details/${product.id}`}
//                               >
//                                 {product.title}
//                               </Link>
//                             </h6>
//                             <div className="rs-product-price">
//                               {product.discountPrice && (
//                                 <span className="rs-product-discount-price">
//                                   ৳{product.discountPrice.toFixed(2)}
//                                 </span>
//                               )}
//                               &nbsp;
//                               <span className="rs-current-price">
//                                 ৳{product.price}
//                               </span>
//                             </div>
//                           </div>
//                         </div> */}
//                         <div className="rs-product-item">
//                           <div className="rs-product-thumb">
//                             <Link
//                               to={`/products/product-details/${product.id}`}
//                             >
//                               <img src={product.image} alt={product.title} />
//                             </Link>

//                             {product.sale && (
//                               <div className="rs-product-badge">
//                                 <span className="rs-circle-badge">Sale!</span>
//                               </div>
//                             )}
//                           </div>

//                           <div className="rs-product-content">
//                             <h6 className="rs-product-title">
//                               <Link
//                                 to={`/products/product-details/${product.id}`}
//                               >
//                                 {product.title}
//                               </Link>
//                             </h6>

//                             <div className="rs-product-price">
//                               {product.discountPrice && (
//                                 <span className="rs-product-discount-price">
//                                   ৳{product.discountPrice.toFixed(2)}
//                                 </span>
//                               )}
//                               &nbsp;
//                               <span className="rs-current-price">
//                                 ৳{product.price}
//                               </span>
//                             </div>
//                           </div>
//                         </div>
//                       </div>
//                       //   );
//                       // })}
//                     );
//                   })
//                 ) : (
//                   <div className="col-12">
//                     <div className="text-center py-5">
//                       <h4>No products found.</h4>
//                     </div>
//                   </div>
//                 )}
//               </div>

//               <div className="common-pagination">
//                 <nav>
//                   <ul>
//                     <li>
//                       <Link className="current">1</Link>
//                     </li>
//                     <li>
//                       <Link to="#">2</Link>
//                     </li>
//                     <li>
//                       <Link to="#">3</Link>
//                     </li>
//                     <li>
//                       <Link to="#">→</Link>
//                     </li>
//                   </ul>
//                 </nav>
//               </div>
//             </div>

//             <div className="col-xxl-4 col-xl-4 col-lg-4">
//               <div className="rs-sidebar-wrapper rs-sidebar-sticky">
//                 <div className="sidebar-widget mb-30">
//                   <div className="sidebar-search">
//                     <form>
//                       <div className="sidebar-search-input">
//                         <input type="text" placeholder="Searching..." />
//                         <button type="submit">
//                           <FaSearch size={18} />
//                         </button>
//                       </div>
//                     </form>
//                   </div>
//                 </div>

//                 <div className="sidebar-widget widget-categories mb-30">
//                   <h5 className="sidebar-widget-title">Categories</h5>
//                   <div className="sidebar-widget-content">
//                     <div className="list">
//                       {/* <ul>
//                         <li>
//                           <Link to="#">All</Link>
//                         </li>
//                         <li>
//                           <Link to="#">Factory</Link>
//                         </li>
//                         <li>
//                           <Link to="#">Industry</Link>
//                         </li>
//                         <li>
//                           <Link to="#">Uncategorized</Link>
//                         </li>
//                       </ul> */}
//                       <ul>
//                         <li>
//                           <Link
//                             to="#"
//                             onClick={(e) => {
//                               e.preventDefault();
//                               setSelectedCategory("All");
//                             }}
//                             className={
//                               selectedCategory === "All" ? "active" : ""
//                             }
//                           >
//                             All
//                           </Link>
//                         </li>

//                         {categories.map((category) => (
//                           <li key={category.id}>
//                             <Link
//                               to="#"
//                               onClick={(e) => {
//                                 e.preventDefault();
//                                 setSelectedCategory(category.category);
//                               }}
//                               className={
//                                 selectedCategory === category.category
//                                   ? "active"
//                                   : ""
//                               }
//                             >
//                               {category.category}
//                             </Link>
//                           </li>
//                         ))}
//                       </ul>
//                     </div>
//                   </div>
//                 </div>

//                 <div className="sidebar-widget widget-price-filter">
//                   <h5 className="sidebar-widget-title">Filter by price</h5>
//                   <div className="sidebar-widget-range pt-10">
//                     <div id="slider-range"></div>
//                     <div className="sidebar-widget-range-amount mt-30">
//                       <Link className="rs-btn" to="#">
//                         Filter
//                       </Link>
//                       <div className="price-filter">
//                         <input type="text" id="amount" />
//                       </div>
//                     </div>
//                   </div>
//                 </div>
//               </div>
//             </div>
//           </div>
//         </div>
//       </section>
//     </Wrapper>
//   );
// };

// const Wrapper = styled.section`
//   /* Product Item */
//   .rs-product-item {
//     width: 100%;
//     background: #ffffff;
//     overflow: hidden;
//   }

//   /* Product Image Area */
//   .rs-product-thumb {
//     position: relative;
//     width: 100%;
//     height: 320px;

//     display: flex;
//     justify-content: center;
//     align-items: center;

//     background: #ffffff;
//     border: 1px solid #eeeeee;

//     overflow: hidden;
//   }

//   .rs-product-thumb a {
//     width: 100%;
//     height: 100%;

//     display: flex;
//     justify-content: center;
//     align-items: center;

//     /* text-decoration: none; */
//   }

//   .rs-product-thumb img {
//     display: block;

//     width: 100%;
//     height: 100%;

//     max-width: 100%;
//     max-height: 100%;

//     object-fit: contain;
//     object-position: center center;

//     /* padding: 10px; */
//   }

//   /* ====== Category Active ====== */
//   .sidebar-widget-content .list ul li a {
//     transition: all 0.3s ease;
//   }

//   .sidebar-widget-content .list ul li a.active {
//     color: #e95500;
//   }

//   /* Large Tablet / Medium Screen */
//   @media (max-width: 991px) {
//     .rs-product-thumb {
//       height: 300px;
//     }

//     /* .rs-product-thumb img {
//       padding: 8px;
//     } */
//   }

//   /* Mobile */
//   @media (max-width: 767px) {
//     .rs-product-thumb {
//       height: 300px;
//     }

//     .rs-product-thumb img {
//       width: 100%;
//       height: 100%;
//       padding: 10px;
//       object-fit: contain;
//     }

//     /* .rs-product-content {
//       padding-top: 15px;
//     } */
//   }
// `;

// export default Product;

import React, { useEffect, useState } from "react";
import {
  FaPlay,
  FaPlus,
  FaChevronLeft,
  FaChevronRight,
  FaLink,
} from "react-icons/fa";
import { Link } from "react-router-dom";
import styled from "styled-components";

import productsArray from "../../DataJS/Products.js";
import categoryData from "../../DataJS/categories.js";

const Product = () => {
  const [products, setProducts] = useState([]);
  // const [activeTab, setActiveTab] = useState("All");
  const [selectedCategory, setSelectedCategory] = useState("All");

  const [isOpen, setIsOpen] = useState(false);
  const [currentIndex, setCurrentIndex] = useState(0);

  useEffect(() => {
    setProducts(productsArray);
  }, []);

  const filteredProducts =
    selectedCategory === "All"
      ? products
      : products.filter((product) => product.categoryId === selectedCategory);

  const handleCategoryChange = (categoryId) => {
    setSelectedCategory(categoryId);
    setCurrentIndex(0);
  };

  // Get the first image of a product
  // const getMainImage = (product) => {
  //   if (
  //     product?.images &&
  //     Array.isArray(product.images) &&
  //     product.images.length > 0
  //   ) {
  //     return product.images[0];
  //   }
  //   return "/assets/images/shop/placeholder.png";
  // };

  // Open Lightbox
  const openModal = (index) => {
    setCurrentIndex(index);
    setIsOpen(true);
  };

  // Close Lightbox
  const closeModal = () => {
    setIsOpen(false);
  };

  // Next Product
  const nextSlide = () => {
    setCurrentIndex((currentIndex + 1) % filteredProducts.length);
  };

  // Previous Product
  const prevSlide = () => {
    setCurrentIndex(
      (currentIndex - 1 + filteredProducts.length) % filteredProducts.length,
    );
  };

  return (
    <Wrapper>
      <section
        className="rs-shop-area section-space"
        style={{ paddingTop: "50px" }}
      >
        <div
          className="rs-section-title-wrapper"
          //   style={{ marginBottom: "50px" }}
        >
          <span className="rs-section-subtitle has-theme-orange justify-content-center text-capitalize">
            <FaPlay color="#EA5501" size={12} />
            Our Products
          </span>
        </div>

        <div className="container pt-4">
          <div className="row">
            <div className="col-md-12">
              <div className="product-tab-item">
                <div className="product-tab-menu d-flex justify-content-center align-items-center">
                  <ul
                    className="nav nav-pills mb-4 d-flex justify-content-center align-items-center gap-2 product-tabs"
                    role="tablist"
                  >
                    {/* ALL BUTTON */}
                    <li className="nav-item" role="presentation">
                      <button
                        type="button"
                        className={`nav-link ${
                          selectedCategory === "All" ? "active" : ""
                        }`}
                        onClick={() => handleCategoryChange("All")}
                      >
                        All
                      </button>
                    </li>

                    {/* CATEGORY BUTTONS */}
                    {categoryData.map((category) => (
                      <li
                        className="nav-item"
                        role="presentation"
                        key={category.id}
                      >
                        <button
                          type="button"
                          className={`nav-link ${
                            selectedCategory === category.id ? "active" : ""
                          }`}
                          onClick={() => handleCategoryChange(category.id)}
                          style={{
                            textTransform: "uppercase",
                            whiteSpace: "nowrap",
                          }}
                        >
                          {category.category}
                        </button>
                      </li>
                    ))}
                  </ul>
                </div>

                <div className="tab-content">
                  <div className="tab-pane fade show active">
                    <div className="row g-4">
                      {filteredProducts.map((item, index) => {
                        // const mainImage = getMainImage(item);

                        return (
                          <div
                            className="col-xl-4 col-lg-4 col-md-6 col-sm-6 col-12"
                            key={item.id}
                          >
                            <div
                              className="gallery-wrapper"
                              style={{ border: "1px solid #eeeeee" }}
                            >
                              <img
                                src={item.image}
                                // src={mainImage}
                                alt={item.title}
                                className="gallery-img"
                                // style={{width: "300px", height: "300px"}}
                              />

                              <div className="gallery-overlay"></div>

                              <div className="gallery-actions">
                                <button
                                  type="button"
                                  className="gallery-btn"
                                  onClick={() => openModal(index)}
                                  aria-label={`View ${item.title}`}
                                >
                                  <FaPlus />
                                </button>

                                <Link
                                  // to={item.link}
                                  to={`/products/product-details/${item.id}`}
                                  className="gallery-link-btn"
                                  aria-label={`View ${item.title}`}
                                >
                                  <FaLink />
                                </Link>
                              </div>

                              {/* Product Content */}
                              <div className="gallery-content">
                                <h4>{item.title}</h4>
                                <span className="text-capitalize fs-4">
                                  {item.subtitle}
                                </span>
                              </div>
                            </div>
                          </div>
                        );
                      })}

                      {/* No Products */}
                      {filteredProducts.length === 0 && (
                        <div className="col-12 text-center">
                          <p>No products available for this category.</p>
                        </div>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {isOpen && filteredProducts.length > 0 && (
        <div
          className="lightbox"
          onClick={closeModal}
          role="dialog"
          aria-modal="true"
        >
          <button
            type="button"
            className="close"
            onClick={closeModal}
            aria-label="Close"
          >
            &times;
          </button>

          <button
            type="button"
            className="lightbox-arrow prev"
            onClick={(event) => {
              event.stopPropagation();
              prevSlide();
            }}
            aria-label="Previous image"
          >
            <FaChevronLeft />
          </button>

          <div
            className="lightbox-content"
            onClick={(event) => event.stopPropagation()}
          >
            <img
              src={filteredProducts[currentIndex].image}
              // src={getMainImage(filteredProducts[currentIndex])}
              alt={filteredProducts[currentIndex].title}
              className="lightbox-img"
            />

            <div className="lightbox-info">
              <h4>{filteredProducts[currentIndex].title}</h4>
              <span className="text-capitalize fs-4">
                {filteredProducts[currentIndex].subtitle}
              </span>
            </div>
          </div>

          <button
            type="button"
            className="lightbox-arrow next"
            onClick={(event) => {
              event.stopPropagation();
              nextSlide();
            }}
            aria-label="Next image"
          >
            <FaChevronRight />
          </button>
        </div>
      )}
    </Wrapper>
  );
};

const Wrapper = styled.section`
  .gallery-wrapper {
    position: relative;
    width: 100%;
    height: 400px;
    overflow: hidden;
    border-radius: 10px;
    background: #f5f5f5;
    cursor: pointer;
  }

  .gallery-img {
    width: 100%;
    height: 100%;
    display: block;
    /* object-fit: cover; */
    object-fit: contain;
    object-position: center center;
    transition: transform 0.5s ease;
  }

  .gallery-overlay {
    position: absolute;
    inset: 0;
    background: rgba(0, 0, 0, 0.45);
    opacity: 0;
    transition: opacity 0.35s ease;
    z-index: 1;
  }

  .gallery-actions {
    position: absolute;
    top: 50%;
    left: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 6px;
    transform: translate(-50%, -50%) scale(0.7);
    opacity: 0;
    visibility: hidden;
    z-index: 3;
    transition: all 0.35s ease;
  }

  .gallery-btn,
  .gallery-link-btn {
    width: 42px;
    height: 42px;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 0;
    background: #ff6118;
    border: none;
    border-radius: 50%;
    color: #ffffff;
    font-size: 14px;
    text-decoration: none;
    cursor: pointer;
    transition: all 0.3s ease;
  }

  .gallery-btn:hover,
  .gallery-link-btn:hover {
    background: #ea5501;
    color: #ffffff;
    transform: scale(1.08);
  }

  .gallery-content {
    position: absolute;
    left: 15px;
    right: 15px;
    bottom: 20px;
    z-index: 3;
    color: #ffffff;
    text-align: center;
    opacity: 0;
    transform: translateY(15px);
    transition: all 0.35s ease;
  }

  .gallery-content span {
    display: block;
    margin-bottom: 4px;
    color: #ffffff;
    font-size: 12px;
    font-weight: 500;
    text-transform: uppercase;
    letter-spacing: 1px;
    text-align: center;
  }

  .gallery-content h4 {
    margin: 0;
    color: #ffffff;
    font-size: 20px;
    font-weight: 600;
    line-height: 1.3;
    text-align: center;
  }

  .gallery-wrapper:hover .gallery-img {
    transform: scale(1.07);
  }

  .gallery-wrapper:hover .gallery-overlay {
    opacity: 1;
  }

  .gallery-wrapper:hover .gallery-actions {
    opacity: 1;
    visibility: visible;
    transform: translate(-50%, -50%) scale(1);
  }

  .gallery-wrapper:hover .gallery-content {
    opacity: 1;
    transform: translateY(0);
  }

  /* ========  PRODUCT TAB  ======== */
  .product-tab-menu {
    width: 100%;
  }

  .product-tabs {
    padding-left: 0 !important;
    overflow-x: auto;
    flex-wrap: nowrap !important;
    -webkit-overflow-scrolling: touch;
  }

  .product-tabs .nav-item {
    margin-bottom: 7px;
  }

  .product-tabs .nav-link {
    border: 1px solid #e5e5e5;
    background: #ffffff;
    color: #333333;
    border-radius: 30px;
    padding: 10px 22px;
    font-size: 14px;
    font-weight: 600;
    transition: all 0.3s ease;
  }

  .product-tabs .nav-link:hover {
    background: #ff6118;
    border-color: #ff6118;
    color: #ffffff;
  }

  .product-tabs .nav-link.active {
    background: #ff6118;
    border-color: #ff6118;
    color: #ffffff;
  }

  .product-tabs::-webkit-scrollbar {
    height: 5px;
  }

  .product-tabs::-webkit-scrollbar-track {
    background: #f1f1f1;
  }

  .product-tabs::-webkit-scrollbar-thumb {
    background: #888;
    border-radius: 4px;
  }

  .product-tabs::-webkit-scrollbar-thumb:hover {
    background: #555;
  }

  .lightbox {
    position: fixed;
    inset: 0;
    width: 100%;
    height: 100vh;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 30px;
    background: rgba(0, 0, 0, 0.94);
    z-index: 99999;
  }

  .lightbox-content {
    position: relative;
    display: flex;
    flex-direction: column;
    align-items: center;
    max-width: 90%;
    max-height: 90vh;
  }

  .lightbox-img {
    display: block;
    max-width: 100%;
    max-height: 75vh;
    object-fit: contain;
    border-radius: 8px;
    box-shadow: 0 10px 40px rgba(0, 0, 0, 0.5);
    /* add background */
    background: #ffffff;
  }

  .lightbox-info {
    margin-top: 15px;
    text-align: center;
  }

  .lightbox-info span {
    display: block;
    color: #ff6118;
    font-size: 13px;
    font-weight: 500;
    text-transform: uppercase;
    letter-spacing: 1px;
  }

  .lightbox-info h4 {
    margin: 5px 0 0;
    color: #ffffff;
    font-size: 22px;
    font-weight: 600;
  }

  .close {
    position: absolute;
    top: 20px;
    right: 30px;
    width: 45px;
    height: 45px;
    display: flex;
    align-items: center;
    justify-content: center;
    background: transparent;
    border: none;
    color: #ffffff;
    font-size: 42px;
    font-weight: 300;
    line-height: 1;
    cursor: pointer;
    z-index: 10;
    transition: all 0.3s ease;
  }

  .close:hover {
    color: #ff6118;
    transform: rotate(90deg);
  }

  .lightbox-arrow {
    position: absolute;
    top: 50%;
    width: 55px;
    height: 55px;
    display: flex;
    align-items: center;
    justify-content: center;
    transform: translateY(-50%);
    background: rgba(255, 255, 255, 0.12);
    border: 1px solid rgba(255, 255, 255, 0.25);
    border-radius: 50%;
    color: #ffffff;
    font-size: 18px;
    cursor: pointer;
    z-index: 10;
    transition: all 0.3s ease;
  }

  .lightbox-arrow:hover {
    background: #ff6118;
    border-color: #ff6118;
  }

  .prev {
    left: 30px;
  }

  .next {
    right: 30px;
  }

  /* ========  TABLET  ======== */
  @media (max-width: 991px) {
    .gallery-wrapper {
      height: 280px;
    }

    .gallery-btn,
    .gallery-link-btn {
      width: 40px;
      height: 40px;
      font-size: 13px;
    }

    .lightbox-arrow {
      width: 48px;
      height: 48px;
    }

    .prev {
      left: 20px;
    }

    .next {
      right: 20px;
    }
  }

  /* ========  MOBILE  ======== */
  @media (max-width: 575px) {
    .product-tabs {
      justify-content: flex-start !important;
    }

    .gallery-wrapper {
      height: 250px;
    }

    .gallery-actions {
      gap: 5px;
    }

    .gallery-btn,
    .gallery-link-btn {
      width: 38px;
      height: 38px;
      font-size: 12px;
    }

    .gallery-content {
      left: 10px;
      right: 10px;
      bottom: 16px;
    }

    .gallery-content h4 {
      font-size: 18px;
    }

    .gallery-content span {
      font-size: 11px;
    }

    .lightbox {
      padding: 15px;
    }

    .lightbox-content {
      max-width: 100%;
    }

    .lightbox-img {
      max-width: 100%;
      max-height: 70vh;
    }

    .lightbox-info h4 {
      font-size: 18px;
    }

    .close {
      top: 10px;
      right: 15px;
      font-size: 36px;
    }

    .lightbox-arrow {
      width: 42px;
      height: 42px;
      font-size: 15px;
    }

    .prev {
      left: 10px;
    }

    .next {
      right: 10px;
    }
  }
`;

export default Product;
